// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/202604301103/js/" + chunkId + "." + {"44":"a36e79a7","225":"49edb35c","481":"4372d0cd","486":"670e389c","770":"524285d9"}[chunkId] + ".0.09534343534576095.chunk.js";
};